import { Opportunity } from "common/api";

export const getProjectValue = (opportunity: Opportunity): number => {
  return opportunity.displayAmount ?? 0;
};
